<template>
  <b-modal id="bv-modal-share-attachment"
           size="lg"
           @ok="shareAttachments"
           ref="modal"
           data-backdrop="static" data-keyboard="false"
           :title="$tr('shareAttachmentDialog.send','Send the attachment by e-mail')"
           ok-variant="plm-primary"
  >
    <template v-slot:modal-title>
      {{$tr("shareAttachmentDialog.send.attachments","Send the attachments by e-mail")}}
    </template>

    <b-container>
      <b-row>
        <b-col>
          <TextPillsList v-model="emails"
                         data-test-path="share-attachments-email"
                         icon="address-book"
                         @icon-clicked="openMailBrowserDialog"
                         :valid.sync="emailsPillsValid"
                         :valid2="emailsPillsValid"
                         :pattern="/\S+@\S+\.\S+/"
                         :label="$tr('emailAddresses','Email addresses')"
                         :errorMessage="$tr('emailInvalidFormat','Emails has invalid format')"
                         :placeholder="$tr('enterEmails','Enter emails')">
          </TextPillsList>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <reach-input
              data-test-path="attachment-subject"
              :label="$tr('subject','Subject')"
              :placeholder="$tr('enterSubject','Enter subject')"
              :form-field="subject"
          >
          </reach-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <FormattedInput data-test-path="attachment-message" v-model="message" height="200"></FormattedInput>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" v-for="item in listOfSelectedAttachments" :key="item.token">
          <a :href="item.downloadUrl">{{ item.data.name }}</a>
          <b-btn variant="plm-toolbar-danger " style="height: 22px; width: 22px" class="border-0 btn-xs"
                 @click.stop="removeItem(item.token)">
            <span style="position: absolute; margin-left: -4px; margin-top: -13px;">x</span>
          </b-btn>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row>
          <b-col
              class="col-12 text-center text-sm-right">
            <b-button
                data-test-path="send-attachment-mail"
                :disabled="!emailsPillsValid || !emails.length"
                variant="plm-save"
                @click="shareAttachments"
            >
              <font-awesome-icon icon="envelope"/>
              {{$tr('send','Send')}}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>


<script>
import VBox from "@/components/VBox";
import ReachInput from "@/components/inputs/ReachInput";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import FormattedInput from "@/components/inputs/controls/FormattedInput";
import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";


export default {
  name: "ChangePasswordDialog",
  components: {FormattedInput, TextPillsList, VBox, ReachInput},

  mounted() {
  },

  methods: {


    async shareAttachments() {
      await Rpc.BusinessEntities.shareAttachments(this.emails, this.subject.value, this.message, this.listOfSelectedAttachments);
      this.$refs.modal.hide();
    },

    reset() {
      this.result = null;
      this.resolve = null;
      this.message = "";
      this.subject = new ValidatedField(new ValidatedForm(), "" );
      this.emails = [];
    },

    removeItem(token) {
      this.listOfSelectedAttachments = this.listOfSelectedAttachments.filter(item => item.token !== token);
    },

    async openMailBrowserDialog() {
      let emails = await DialogManager.mailBrowser();
      for (let i = 0; i < emails.length; i++) {
        this.emails.push(emails[i]);
      }
    }

  },
  data: () => ({
    emails: [],
    emailsPillsValid: true,
    message: '',
    subject: new ValidatedField(new ValidatedForm(), "" ),
    listOfSelectedAttachments: [],
  })
}
</script>
